import { environment } from "../../../environment/environment";

import Clarity from "@microsoft/clarity";

export function initClarity() {
  return () => {
    environment.enableClarity && Clarity.init(environment.clarityProjectId);
  };
}
